import { orange } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { breakpoints } from '@/theme/tokens'
import styled from 'styled-components'

export const BrandRoot = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 9px;

	img {
		width: 26px;
		height: 26px;
	}

	@media (max-width: ${breakpoints.phone}px) {
		gap: 7px;

		img {
			width: 22px;
			height: 22px;
		}
	}
`

export const BrandWordmark = styled.b`
	font-family: ${fontDisplay};
	font-weight: 900;
	font-size: 22px;
	color: ${orange};
	letter-spacing: -0.01em;

	@media (max-width: ${breakpoints.phone}px) {
		font-size: 19px;
	}
`
